import { render, staticRenderFns } from "./RequestQuote.vue?vue&type=template&id=1b336906&scoped=true"
import script from "./RequestQuote.vue?vue&type=script&lang=ts"
export * from "./RequestQuote.vue?vue&type=script&lang=ts"
import style0 from "./RequestQuote.vue?vue&type=style&index=0&id=1b336906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b336906",
  null
  
)

export default component.exports